import './js/header';
import './js/switch';
import './js/mobile-menu';
import './js/login';
import './js/render-list-of-readed';
import './js/scroll-button';
import './js/add-to-favourite';
